import React from 'react';
import { Box, Stack } from '@mui/material';
import type { FlowMode } from '../../utils/whatsappWorkingHours';
import { UI } from './settingsUi';

export const FlowModeControl = ({ mode, label, onChange, compact = false }: {
  mode: FlowMode;
  label: string;
  onChange: (mode: FlowMode) => void;
  compact?: boolean;
}) => (
  <Stack direction="row" role="radiogroup" aria-label={`${label} sending mode`} onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}
    sx={{ border: `1px solid ${UI.line}`, borderRadius: 1.25, p: 0.25, bgcolor: UI.canvas, flexShrink: 0 }}>
    {(['off', 'test', 'live'] as FlowMode[]).map((value) => {
      const selected = mode === value;
      return <Box key={value} component="button" type="button" role="radio" aria-checked={selected}
        aria-label={`${label}: ${value}`} onClick={() => onChange(value)}
        sx={{ border: 0, borderRadius: 1, minHeight: compact ? 27 : 34, minWidth: compact ? 37 : 50,
          px: compact ? 0.5 : 1, cursor: 'pointer', fontFamily: UI.body, fontSize: compact ? 10.5 : 12,
          fontWeight: selected ? 700 : 500, color: selected ? (value === 'live' ? '#246537' : UI.ink) : UI.muted,
          bgcolor: selected ? (value === 'live' ? '#eaf5ec' : UI.surface) : 'transparent',
          boxShadow: selected ? `0 1px 3px ${UI.line}` : 'none',
          '&:focus-visible': { outline: `2px solid ${UI.gold}`, outlineOffset: 1 } }}>
        {value === 'off' ? 'Off' : value === 'test' ? 'Test' : 'Live'}
      </Box>;
    })}
  </Stack>
);
